module.exports = __webpack_public_path__ + "static/media/WHITE HART A3 MENU VERSION AUG 26.fd5aa0b0.pdf";